"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hideLeftPanel = exports.HIDE_LEFT_PANEL = exports.toggleLeftColumn = exports.TOGGLE_LEFT_COLUMN = void 0;

var _getActionName = require("../../skybase-core/utils/get-action-name");

var _createAction = require("../../skybase-core/base/create-action");

var _constants = require("../../constants");

var TOGGLE_LEFT_COLUMN = (0, _getActionName.getActionName)('TOGGLE_LEFT_COLUMN', _constants.MODULE_NAME);
exports.TOGGLE_LEFT_COLUMN = TOGGLE_LEFT_COLUMN;

var toggleLeftColumn = function toggleLeftColumn() {
  return (0, _createAction.createAction)(TOGGLE_LEFT_COLUMN);
};

exports.toggleLeftColumn = toggleLeftColumn;
var HIDE_LEFT_PANEL = (0, _getActionName.getActionName)('HIDE_LEFT_PANEL', _constants.MODULE_NAME);
exports.HIDE_LEFT_PANEL = HIDE_LEFT_PANEL;

var hideLeftPanel = function hideLeftPanel(isHidden) {
  return (0, _createAction.createAction)(HIDE_LEFT_PANEL, {
    isHidden: isHidden
  });
};

exports.hideLeftPanel = hideLeftPanel;
//# sourceMappingURL=actions.js.map